import template from './index.html'
import {getScreenWidth, getScreenHeight} from '../../helpers'

const playerColored = (i, player) => {
  switch (i) {
    case 0:
      player.setStyle('background-color: red;')
      break
    case 1:
      player.setStyle('background-color: green;')
      break
    case 2:
        player.setStyle('background-color: yellow;')
        break
    case 3:
      player.setStyle('background-color: orange;')
      break
    case 4:
      player.setStyle('background-color: gray;')
      break
    case 5:
      player.setStyle('background-color: cyan;')
      break
    case 6:
      player.setStyle('background-color: blue;')
      break
    case 7:
      player.setStyle('background-color: lightgray;')
      break
  }
}

const pageCinema = () => {
  let playerSizes = []
  return {
    transitionEffect: false,
    players: [],
    title: 'ИЗБРАННОЕ',
    path: '',
    orientation: 'vertical',
    i: 0,
    fullscreenCam: null,
    async init() {
      this.root = this

      const context = await this.callIOS('getContext')
      this.path = context.path

      this.app.on('orientation', this.changeOrientation, this)

      this.$el.innerHTML = template

      this.callIOS('setWebViewParams', { params: [['opacity', 1]] })
    },
    async makeSlidesVertical() {
      const screenWidth = getScreenWidth()
      const screenHeight = getScreenHeight()

      let nextX = 0
      let nextY = 0
      let prevH = 0

      let verCount = 0
      let inRowCount = 0

      this.players.forEach(async (player, i) => {
        if (this.fullscreenCam == player.id || playerSizes[i]) {
          verCount +=2
          if (inRowCount>0) {
            verCount++
            inRowCount = 0
          }
        } else {
          inRowCount++
        }
        if (inRowCount == 2) {
          verCount++
          inRowCount = 0
        }
      })
      if (inRowCount>0) verCount++

      let oneHeight = (screenHeight-48-56)/verCount
      if (oneHeight> 150) oneHeight = 150

      for (let i=0; i < this.players.length; i++) {
        const player = this.players[i]
        let w = 0
        let h = 0

        if (this.fullscreenCam == player.id || playerSizes[i]) {
          if (nextX !=0 )  {
            nextX = 0
            nextY += prevH
          }
          w = screenWidth
          h =  oneHeight*2
        } else {
          w = screenWidth / 2
          h = oneHeight
        }
        await player.setTop(nextY)
        await player.setLeft(nextX)
        await player.setWidth(w)
        await player.setHeight(h)

        nextX += w
        nextY += 0
        if (nextX >= screenWidth) {
          nextX = 0
          nextY += h
        }
        prevH = h

        //playerColored(i, player)
      }

      this.context.app.callIOS('setScrollParams', { params: [['top',56]] })
      this.context.app.callIOS('setCamGridParams', { params: [['rotate', 0], ['marginLeft',0], ['width', 32 * window.innerHeight], ['height', 'auto']] })
    },
    async makeSlidesHorizontal() {
      const screenWidth = getScreenWidth()
      const screenHeight = getScreenHeight()

      let nextX = 0
      let nextY = 0
      let prevH = 0

      /*this.players.forEach(async (player, i) => {
        let ww = 0
        let hh = 0

        if (playerSizes[i]) {
          if (nextX !=0 )  {
            nextX = 0
            nextY += prevH
          }
          ww = screenWidth
          hh = this.context.app.orientation == 'portrait' ? 300 : screenHeight
        } else {
          ww = screenWidth / 2
          hh = this.context.app.orientation == 'portrait' ? 150 : screenHeight
        }
        await player.setTop(nextY)
        await player.setLeft(nextX)
        await player.setWidth(ww)
        await player.setHeight(hh)
        nextX += ww
        nextY += 0
        if (nextX >= screenWidth) {
          nextX = 0
          nextY += hh
        }
        prevH = hh
      })*/

        /*
        this.players.forEach(async (player, i) => {
          //if (i==0) return
          let w = 0
          let h = 0
  
          if (this.players.length > 4) {
            w = screenHeight/3
            h = screenWidth/2
          } else if (this.players.length >=3) {
            w = screenHeight/2
            h = screenWidth/2
          } else if (this.players.length == 2) {
              w = screenHeight/2
              h = screenHeight/2
          } else {
            w = screenHeight
            h = screenWidth
          }
          await player.setWidth(w)
          await player.setHeight(h)
          await player.setRotate(90)
          const left = (w - h)/2
          const top = (h + w)/2
          //await player.setTop(0)
          await player.setTop(top+nextY-h)
          if (i==0 || i==3) {
            player.attrClass = 'bg-red-600 border border-green-600 '
          } else {
            //await player.setTop(left+nextY)
            player.attrClass = 'bg-red-500 border border-green-500'
          }
          
          await player.setLeft(-left+screenWidth-h+nextX)

          nextX += 0
          nextY += w
          if (nextY >= screenHeight) {
            nextX -= h
            nextY = 0
          }
          prevH = h
        })*/
        
        for (let i=0; i < this.players.length; i++) {
          const player = this.players[i]
          //if (i==0) return
          let w = 0
          let h = 0
  
          if (this.fullscreenCam != null) {
            if (this.fullscreenCam == player.id) {
              w = screenWidth
              h = screenHeight
              nextX = 0
              nextY = 0
            } else {
              nextX = 10000
            }
          } else if (this.players.length >= 7) {
            w = screenWidth/3
            h = screenHeight/3
          } else if (this.players.length >= 5) {
            w = screenWidth/3
            h = screenHeight/2
          } else if (this.players.length >=3) {
            w = screenWidth/2
            h = screenHeight/2
          } else if (this.players.length == 2) {
              w = screenWidth/2
              h = screenHeight
          } else {
            w = screenWidth
            h = screenHeight
          }
          await player.setWidth(w)
          await player.setHeight(h)
          await player.setRotate(0)
          const left = (w - h)/2
          const top = (h + w)/2
          //await player.setTop(0)
          await player.setTop(nextY)
          await player.setLeft(nextX)

          nextX += w
          nextY += 0
          if (nextX >= screenWidth) {
            nextX = 0
            nextY += h
          }
          prevH = h
          //playerColored(i, player)
        }

      const left = (screenWidth - screenHeight)/2
      const top = (screenHeight + screenWidth)/2

      //this.callIOS('setCamGridParams', { params: [['width', window.innerWidth], ['height', nextY]] })

      //this.callIOS('setScrollParams', { params: [['scrollX', 0], ['scrollY', 0]]})

      //this.callIOS('setScrollParams', { params: [['iosOverflowSafeAreaEnabled', false],['className', 'bg-green-500 border border-orange-500 text-center'], ['top', -48],['width', 'auto'], ['height', 'auto'], ['visibility', 'visible'], ['verticalAlignment', 'top'] ] })
      //console.log('size', getScreenWidth(), getScreenHeight())
      //this.callIOS('setCamGridParams', { params: [['position', 'absolute'],['top',400],['left', 400] ['marginLeft',0] ,['width', getScreenHeight()], ['height',getScreenWidth()], ['className', 'bg-red-500'], ['rotate', 0] ] })
      //this.callIOS('setWebViewParams', { params: [['opacity', '1']] })

      //this.callIOS('setScrollParams', { params: [['top',-48]] })

      //this.callIOS('setCamGridParams', { params: [['horizontalAlignment','left'],['verticalAlignment','top'],['clipToBounds', false],['originX', 0],['originY',0],['rotate', 90], ['marginLeft',screenWidth], ['top',0], ['marginTop', 1],['marginTop', 0], ['width', screenWidth], ['height', screenHeight]] })
      

    },
    play() {
      this.players.forEach(player => {
        player.attrClass = ''
        player.play()
      })
    },
    stop() {
      this.players.forEach(player => {
        player.stop()
      })
    },
    deactivating() {
      console.log('deactivating cinema')
      this.stop()
    },
    activating() {
      console.log('activating cinema')
      window._app.callIOS('setScrollOffset', 0)
      this.players.forEach(player => {
        player.nativeShow()
      })
      this.play()
    },
    async apply() {
      return new Promise(resolve => {
        this.$nextTick(_ => {
          resolve()
        })
      })
    },
    async navigatingTo() {
      console.log('navigatingTo cinema')
      this.fullscreenCam = null
      this.players = []
      playerSizes = []
      await this.apply()

      this.$store.state.cinemaItems.forEach((item, i) => {
        const camera = this.context.app.getCamera(item.id)
        if (!camera) return
        const device = this.context.app.getDevice(camera.deviceId)
        if (!device) return
        playerSizes.push(item.x2)
        this.players.push(this.context.app.components.player({
          id: this.i++,
          attrClass: 'bg-black',
          camera,
          device,
          path: this.path,
          onDblClick() {
            if (this.fullscreenCam == this.id) {
              this.fullscreenCam = null
            } else {
              this.fullscreenCam = this.id
            }
            this.context.app.orientation == 'portrait' ? this.makeSlidesVertical() : this.makeSlidesHorizontal()
          }
        }))
      })
      this.context.app.orientation == 'portrait' ? this.makeSlidesVertical() : this.makeSlidesHorizontal()
    },
    navigatingFrom() {
      console.log('navigatingFrom cinema')
      this.players = []
      console.log('cinema closed')
      this.app.off('orientation', this.changeOrientation)
    },
    navigatedFrom() {
      console.log('navigatedFrom cinema')
      this.players = []
      console.log('cinema closed')
    },
    openMenu() {
      this.app.showMenu = true
    },
    openSettings() {
      this.app.goPage('cinemaEdit')
    },
    scroll(event) {
      //this.callIOS('setScrollParams', { params: [['scrollY', event.target.scrollTop]]})
    },
    changeOrientation(orientation) {
      this.fullscreenCam = null
      this.context.app.orientation == 'portrait' ? this.makeSlidesVertical() : this.makeSlidesHorizontal()
    }
  }
}

export { pageCinema }
